import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Linkify from 'linkify-react';

import ImageApi from '../../../api/image';
import { TranslateApi } from '../../../api';
import PhoneIcon from '../../../assets/images/phone.svg';
import ContactIcon from '../../../assets/images/contact.svg';
import LocationIcon from '../../../assets/images/location.svg';

import WorshipLocationDetailsHeader from '../componests/WorshipLocationDetailsHeader';

const WorshipLocationDetailsItem = ({ worship, addAlertToAlerts, currentUser }) => {
  const navigate = useNavigate();
  const [image, setImage] = useState('');
  const [isTranslated, setIsTranslated] = useState(false);
  const [title, setTitle] = useState(worship.title);
  const [description, setDescription] = useState(worship.description);
  const [location, setLocation] = useState(worship.location);
  const [details, setDetails] = useState(worship.details);
  const [religion, setReligion] = useState(worship.religion_name);

  useEffect(() => {
    if (worship.image && worship.image.url) {
      ImageApi.getImage(worship.image.url).then((imageUrl) => {
        setImage(imageUrl);
      });
    }
  }, [worship.id, worship.image]);

  const onTranslateClicked = async() => {
    setIsTranslated(!isTranslated)
    let translatedTitle, translatedLocation, translatedDetails, translatedDescription, translatedReligion;

    if (isTranslated) {
      setTitle(worship.title);
      setDescription(worship.description);
      setLocation(worship.location);
      setDetails(worship.details);
      setReligion(worship.religion_name);

      return null
    }

    if (currentUser.language_id) {
      const resultTitle = await TranslateApi.getTranslation(currentUser.language_id, title)
      if (resultTitle && resultTitle.success) {
        translatedTitle = resultTitle.data
      }
  
      const resultLocation = await TranslateApi.getTranslation(currentUser.language_id, location)
      if (resultLocation && resultLocation.success) {
        translatedLocation = resultLocation.data
      }

      const resultDetails = await TranslateApi.getTranslation(currentUser.language_id, details)
      if (resultDetails && resultDetails.success) {
        translatedDetails = resultDetails.data
      }

      const resultDescription = await TranslateApi.getTranslation(currentUser.language_id, description)
      if (resultDescription && resultDescription.success) {
        translatedDescription = resultDescription.data
      }
      const resultReligion = await TranslateApi.getTranslation(currentUser.language_id, religion)
      if (resultReligion && resultReligion.success) {
        translatedReligion = resultReligion.data
      }

    if (!translatedLocation || !translatedTitle || !translatedDetails || !translatedDescription || !translatedReligion) {
      addAlertToAlerts({
        title: 'Message',
        message: 'Translation to your selected language is not currently available.',
        confirmBtnText: 'Okay',
      });

      setIsTranslated(false)
    } else {
      setTitle(translatedTitle);
      setDescription(translatedDescription);
      setLocation(translatedLocation);
      setDetails(translatedDetails);
      setReligion(translatedReligion);
    }
    } else {
      addAlertToAlerts({
        title: 'Message',
        message: 'User does not have a language configured.',
        confirmBtnText: 'Okay',
      });
      setIsTranslated(false)
    }
  }

  return (
    <div className="worship-details-container-inner">
      <WorshipLocationDetailsHeader
        createdAt={worship.created_at}
        author={worship.author}
        worshipId={worship.id}
        goBack={() => navigate(-1)}
      />
      <div className="p-3">
        {image ? (
          <img className="worship-details-container-image" src={image} alt="community-thumbnail" />
        ) : null}
        <div className="d-flex flex-row justify-content-between">
          <p className="worship-details-container-title mt-4">{title}</p>
          <p className="worship-details-container-title mt-4" style={{ color: '#F6911E' }}>
            {religion}
          </p>
        </div>

        <p className="worship-details-container-text mt-2 pb-5">{description}</p>
        {worship.location ? (
          <>
            <div className="worship-details-container-contact">
              <img width="28" height="28" src={LocationIcon} alt="location icon" />
              <p className="worship-details-container-text pl-3">{location}</p>
            </div>
            <div className="worship-details-container-divider" />
          </>
        ) : null}
        {worship.phone ? (
          <>
            <div className="worship-details-container-contact">
              <img width="28" height="28" src={PhoneIcon} alt="phone icon" />
              <p className="worship-details-container-text pl-3">{worship.phone}</p>
            </div>
            <div className="worship-details-container-divider" />
          </>
        ) : null}

        {worship.email_address ? (
          <>
            <div className="worship-details-container-contact">
              <img width="28" height="28" src={ContactIcon} alt="contact icon" />
              <a
                className="worship-details-container-text community-container-text-decorator pl-3"
                href={`mailto:${worship.email_address}`}
              >
                {worship.email_address}{' '}
              </a>
            </div>
            <div className="worship-details-container-divider" />
          </>
        ) : null}
      </div>

      <div className="p-3">
        <p className="worship-details-container-title">Details</p>
        <Linkify
          options={{target: {
            url: '_blank'
          }}}
          className="worship-details-container-text"
        >
          {details}
        </Linkify>
      </div>
      <div className="worship-details-item-footer w-100 d-flex justify-content-end m-0 p-0 align-items-center" style={{cursor: 'pointer', right: 25, paddingTop: 20}} onClick={onTranslateClicked}>
        <p className="m-0 p-0 pr-2">{`${isTranslated ? "Show original" : "Translate this"}`}</p>
      </div>
    </div>
  );
};

export default WorshipLocationDetailsItem;
